<custom-header></custom-header>
<div class="container">
    <ng-content></ng-content>
</div>
<custom-footer></custom-footer>
<a [href]="whatsappUrl" target="_blank" class="whatsapp">
  <img src="../../../../assets/images/whatsApp.svg" width="35" height="35"/>
</a>
